import React, {Component} from "react";
import moment from "moment";
import "./ScheduledJobs.css"
import {toast} from "react-toastify";
import Api from "../../api/Api";
import Authentication from "../../authentication/Authentication";
import EditJobContainer from "../scheduledJobs/EditJobContainer"

export default class ScheduledJobsInfo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            verificationAbortInstance: false,
            showEditJobPopup: false
        }

        this.authentication = new Authentication();
    }

    formatDate(date) {
        const momentDate = moment(date)
        if (momentDate.isValid()) {
            return momentDate.format("MMMM Do YYYY HH:mm:ss");
        }
        return "";
    };


    handleCustomiseScheduledDate = (userInstanceId, customDate) => {
        const api = new Api();

        if (this.authentication.isAdmin()) {
            api.customScheduledJobEndDate(this.props.refresh, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, userInstanceId, customDate);
        }
    }

    toggleEditPopup = () => {
        this.setState({
            showEditJobPopup: !this.state.showEditJobPopup
        })
    }



    getLocaleTime = (type) => {
        const databaseTime = new Date(this.props.job.current_time_utc).getTime();
        const signupDate = type === "create" ? new Date(this.props.job.create_date).getTime() : new Date(this.props.job.scheduled_date).getTime();
        const currentLocaleDate = new Date().getTime();
        const UTCLocaleDifference = Math.round((currentLocaleDate - databaseTime) / 100000) * 100000;
        const momentDate = moment(signupDate + UTCLocaleDifference)
        momentDate.format("MMMM Do YYYY HH:mm:ss")
        return momentDate
    }

    render() {
        const localTimeCreate = this.getLocaleTime("create")
        const localTimeUpdate = this.getLocaleTime()
        return (
            <>
                <tbody>
                <tr className={"table-row"} data-testid="job.table.row">
                    <th className={"table-cell"} data-testid="job.table.cell.serviceName">{this.props.job.service_name}</th>
                    <th className={"table-cell"} data-testid="job.table.cell.email">{this.props.job.email}</th>
                    <th className={"table-cell"} data-testid="job.table.cell.job">{this.props.job.description}</th>
                    <th className={"table-cell"} data-testid="job.table.cell.status">{this.props.job.status[0].toUpperCase() + this.props.job.status.substring(1)}</th>
                    <th className={"table-cell"} data-testid="job.table.cell.createdDate">{this.formatDate(localTimeCreate)}</th>
                    <th className={"table-cell"} data-testid="job.table.cell.scheduledDate">{this.formatDate(localTimeUpdate)}</th>
                    <th className={"table-cell"} data-testid="job.table.cell.editJob"  onClick={() => this.toggleEditPopup()}><i className="fa fa-pencil edit-icon" data-testid="job.table.button.editJob" aria-hidden="true"></i></th>
                </tr>
                </tbody>
                {this.state.showEditJobPopup ? <EditJobContainer currentScheduledDate={this.props.job.scheduled_date} handleCustomiseScheduledDate={this.handleCustomiseScheduledDate} job={this.props.job} toggleEditPopup={this.toggleEditPopup}/> : <></>}
            </>
        );
    }
}



